import React, { useState } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import ServicepackageForm from "../../components/servicepackages/ServicepackageForm";
import { convertToFormData } from "../../shared/upload";
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/servicepackages_enum";
import {
  useUpdateServicepackage,
  useSingleServicepackage,
  useGetDropdownOptions,
} from "../../shared/hooks/UseServicepackage";
import AddForm from "../../components/common/AddForm";
// import { useSelectAllServicepackage } from "../../shared/hooks/UseServicepackage";

const EditServicepackage = ({ match }) => {
  let history = useHistory();
  const [single_data] = useSingleServicepackage(match.params.id);
  const [updateData] = useUpdateServicepackage();
  const {
    servicepackage_loading,
    servicepackage,
    edit_servicepackage_loading,
  } = single_data;
  const [featuredImage, setFeaturedImage] = useState(null);

  const [dropdownOptions] = useGetDropdownOptions();
  const submitFormClicked = async (values) => {
    const data = await convertToFormData({ values, featuredImage });
    await updateData(servicepackage._id, data);
    history.push(`/${LINK_URL}/${servicepackage._id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!servicepackage_loading ? (
              servicepackage && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {servicepackage[Object.keys(inputFields)[0]]} -{" "}
                        <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link
                          to={`/${LINK_URL}`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-angle-left"></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${servicepackage._id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={servicepackage}
                    edit={true}
                    featuredImage={featuredImage}
                    setFeaturedImage={setFeaturedImage}
                    submitForm={submitFormClicked}
                    inputFields={inputFields}
                    initialValues={initialValues}
                    dropdown_options={dropdownOptions}
                    loading={edit_servicepackage_loading}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditServicepackage;
